/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'today-pay': {
    width: 47,
    height: 46,
    viewBox: '0 0 47 46',
    data: '<defs><linearGradient id="svgicon_today-pay_a" x1=".5" x2=".5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#27d877"/><stop offset="1" stop-color="#12ba68"/></linearGradient></defs><g transform="translate(1078 407)"><rect pid="0" data-name="矩形 34" width="47" height="46" rx="14" transform="translate(-1078 -407)" _fill="url(#svgicon_today-pay_a)"/><path pid="1" d="M-1067-371.955a9.16 9.16 0 1 1 18.321 0h-18.32zm9.16-10.305a6.87 6.87 0 1 1 6.873-6.873 6.868 6.868 0 0 1-6.873 6.873zm11.451 4.581h4.58v2.29h-4.58zm-3.435-5.725h8.015v2.29h-8.016zm2.289-5.729h5.725v2.29h-5.725z" _fill="#fff"/></g>'
  }
})
